import React from 'react'

export default function Organos({descripcion, setDescripcion, asignarAntecedente}) {

  const handleClicked = async (id_antecedente, observacion, tiene, cp, sp, id_categoria_antecedente) => {
    // obtener la query de la url
    const urlParams = new URLSearchParams(window.location.search)
    let id_paciente = urlParams.get('idpaciente')
    let id_cita = urlParams.get('idcita');
    //alert("handlerClicked");
    //alert(id_cita);
    if(!id_paciente) return console.log('No se encontro el id del paciente')
    await asignarAntecedente(id_antecedente, observacion, Number(id_paciente), tiene, cp, sp, id_categoria_antecedente,Number(id_cita))
  }

  const handleObservacion = async (id_antecedente, id_categoria_antecedente, e) => {
    const urlParams = new URLSearchParams(window.location.search)
    let id_paciente = urlParams.get('idpaciente')
    let id_cita = urlParams.get('idcita');
    //alert("handlerObservacion");
    //alert(id_cita);

    if(!id_paciente) return console.log('No se encontro el id del paciente')

    let filtro = descripcion.filter((desc) => desc.id_antecedente === id_antecedente)
    if(filtro.length === 0) return console.log('No se encontro el antecedente')

    filtro[0].antecedentes_paciente[0].observacion = e.target.value
    const {observacion, tiene, cp, sp} = filtro[0].antecedentes_paciente[0]
    await asignarAntecedente(id_antecedente, observacion, Number(id_paciente), tiene, cp, sp, id_categoria_antecedente,id_cita)
  }

  const handleObservacionChange = (id_antecedente, id_categoria_antecedente, e) => {
    // actualizar el estado de la observacion
    descripcion.map((desc) => {
      if(desc.id_antecedente === id_antecedente && desc.id_categoria_antecedente === id_categoria_antecedente){
        desc.antecedentes_paciente[0].observacion = e.target.value
      }
    })
    setDescripcion([...descripcion])
  }

  const handleValues = (antecedentes_paciente)=>{
    if(antecedentes_paciente && antecedentes_paciente.length > 0){
      const { cp, sp } = antecedentes_paciente[0]
      if(cp === true ||  sp === true){
        return false
      }else{
        return true
      }
    }else{
      return true
    }
  }
  return (
    <>
      <h5>REVISION DE ORGANOS</h5>
      <div className="row">
        <div className="col-6 d-flex align-items-center ">
          <p className='mx-3'>CP</p>
          <p>SP</p>
        </div>
        <div className="col-6 d-flex align-items-center ">
          <p className='mx-3'>CP</p>
          <p>SP</p>
        </div>
        {
          descripcion.map((desc, index) => {
            console.log("Descripcion: ", desc.antecedentes_paciente && desc.antecedentes_paciente.length > 0 ? desc.antecedentes_paciente[0].observacion : '')
            return <div className="col-6 d-flex justify-content-between align-items-center mb-3"
            key={index+1} >
              <div className="form-check form-switch form-switch-md ">
                <input className="form-check-input" type="checkbox" name={String(desc.descripcion).replace(/ /g, "")
                .replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o")
                .replace(/ú/g, "u").replace(/ñ/g, "n").toLowerCase()}
                id={String(desc.descripcion).replace(/ /g, "")
                .replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o")
                .replace(/ú/g, "u").replace(/ñ/g, "n").toLowerCase()}
                checked={desc.antecedentes_paciente && desc.antecedentes_paciente.length > 0 ? desc.antecedentes_paciente[0].cp : false}
                onClick={(e) => handleClicked(desc.id_antecedente, null, false, e.target.checked, false, desc.id_categoria_antecedente)}
                />
              </div>
              <div className="form-check form-switch form-switch-md ">
                <input className="form-check-input" type="checkbox" name={String(desc.descripcion).replace(/ /g, "")
                .replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o")
                .replace(/ú/g, "u").replace(/ñ/g, "n").toLowerCase()}
                id={String(desc.descripcion).replace(/ /g, "")
                .replace(/á/g, "a").replace(/é/g, "e").replace(/í/g, "i").replace(/ó/g, "o")
                .replace(/ú/g, "u").replace(/ñ/g, "n").toLowerCase()}
                checked={desc.antecedentes_paciente && desc.antecedentes_paciente.length > 0 ? desc.antecedentes_paciente[0].sp : false}
                onClick={(e) => handleClicked(desc.id_antecedente, null, false, false, e.target.checked, desc.id_categoria_antecedente)}
                />
              </div>
                <label className="form-check-label w-50" htmlFor="flexSwitchCheckChecked">{desc.descripcion}</label>
                <input type="text" className="form-control" placeholder="Observacion"
                  disabled={handleValues(desc.antecedentes_paciente)}
                  // value={desc.antecedentes_paciente && desc.antecedentes_paciente.length > 0 ? desc.antecedentes_paciente[0].observacion : ''}
                  value={[desc.antecedentes_paciente && desc.antecedentes_paciente.length > 0 ? desc.antecedentes_paciente[0].observacion : ''] || ''}
                  id={String(desc.descripcion).replace(/ /g, "")+desc.id_antecedente}
                  name={String(desc.descripcion).replace(/ /g, "")+desc.id_antecedente}
                  onChange={(e) => handleObservacionChange(desc.id_antecedente, desc.id_categoria_antecedente, e)}
                  onKeyDown={(e) => {
                    if(e.key === 'Enter'){
                      handleObservacion(desc.id_antecedente, desc.id_categoria_antecedente, e)
                    }
                  }}

                />
            </div>

          })
        }
      </div>
    </>
  )
}
